import { render, staticRenderFns } from "./ProjetoCard.vue?vue&type=template&id=4c33d84e&"
import script from "./ProjetoCard.vue?vue&type=script&lang=js&"
export * from "./ProjetoCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjetoCard.vue?vue&type=style&index=0&id=4c33d84e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports